export function SelectSorting({ order, setOrder }) {
  return (
    <div className="flex flex-col gap-0">
      <label htmlFor="selectSort" className="font-bold text-sm">
        Trier par :
      </label>
      <select
        id="selectSort"
        value={order}
        className="border p-1 bg-white border-black sm:text-xs md:text-sm lg:text-base"
        onChange={(e) => setOrder(e.target.value)}
      >
        <option value="surname">Nom</option>
        <option value="name">Prénom</option>
      </select>
    </div>
  );
}
